import { MaterialReactTable } from "material-react-table";

export default function ExhibitorCategoryTable({
  data,
  loading,
  onEdit,
  onDelete,
}) {
  const columns = [
    {
      accessorKey: "name",
      header: "Exhibitor Category",
    },
    {
      header: "Actions",
      Cell: ({ row }) => (
        <div className="flex gap-2">
          <button
            onClick={() => onEdit(row.original)}
            className="rounded bg-yellow-100 px-3 py-1 text-xs"
          >
            Edit
          </button>
          <button
            onClick={() => onDelete(row.original._id)}
            className="rounded bg-red-100 px-3 py-1 text-xs"
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      state={{ isLoading: loading }}
      enableExpanding
      getSubRows={(row) => row.children}
      muiTableBodyRowProps={{ hover: true }}
      enableGlobalFilter={false}
    />
  );
}